import React, { FC } from 'react';
import { ITableProps } from 'molecules/Table/types';
import { Table } from '@mui/material';
import TableBody from 'molecules/Table/TableBody';

const HeadlessTable: FC<ITableProps> = ({
  idKey,
  emptyText,
  hover,
  loading,
  size,
  columns,
  data,
  collapsible,
  collapsedRow,
  onRowClick,
  rowDetailsRenderer,
  ...props
}) => (
  <Table {...props}>
    <TableBody
      size={size}
      hover={hover}
      loading={loading}
      columns={columns}
      data={data}
      emptyText={emptyText}
      idKey={idKey}
      collapsible={collapsible}
      collapsedRow={collapsedRow}
      onRowClick={onRowClick}
      rowDetailsRenderer={rowDetailsRenderer}
    />
  </Table>
);

export default HeadlessTable;
